import { useEffect } from "react";
import { useAppSelector } from "../../../../redux/store";
import { useSnackbar } from "notistack";

import PendingInvoices from "./PendingInvoices";
import InvoiceDetailsDrawer from "./InvoiceDetailsDrawer";
import ProjectDetailsDrawer from "../Projects/components/ProjectDetailsDrawer";

export default function PendingInvoicesComponent() {
  const { invoiceChargeStatus, invoiceChargeError } = useAppSelector(
    (state) => state.invoices
  );

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (invoiceChargeStatus === "succeeded") {
      enqueueSnackbar("Invoice charged successfully", { variant: "success" });
    }
    if (invoiceChargeStatus === "failed") {
      enqueueSnackbar(invoiceChargeError, {
        variant: "error",
      });
    }
  }, [invoiceChargeStatus, enqueueSnackbar, invoiceChargeError]);

  return (
    <>
      <PendingInvoices />
      <InvoiceDetailsDrawer />
      <ProjectDetailsDrawer />
    </>
  );
}
